import { Fragment, useContext, useState } from "react";
import Button from "../organism/Button";
import { useLocation } from "react-router-dom";
import { selectedRowsState } from "../../services/context/selectedRowsIDContext";
import useAssociateLabel from "../../services/utils/custom hooks/Shipments/useAssociateLabel";

function ViewOrders({ row }: { cell: any; row: any ,table:any}) {
  const location = useLocation();
  const { state, dispatch: dispatchRows  } = useContext(selectedRowsState);
  const selectedRowIds:any = state
  const { viewOrderPopup } = state
  const [selecting,setSelecting]=useState<boolean>(false)

  const togglePopup = () => {
    dispatchRows({ type: "SET_VIEW_ORDER_POPUP", payload: !viewOrderPopup });
    dispatchRows({ type: "SET_SELECTED_ROWS_IDS", payload: row.original.id });
  };

  const { mutate: associateLabel } = useAssociateLabel(setSelecting);
  
  if (location?.pathname === "/access/shipments/unshipped-orders") {
    return (
      <td>
        <Button
          textInformation={{ text: "Select", fontWeight: "font-semibold" }}
          buttonTheme="transparent"
          className="text-[#18b5b7]"
          loading={selecting}
          disabled={selecting}
          onClick={() =>
            associateLabel({ orderIds: selectedRowIds?.selectedRowsID?.map((e: any) => e?.id), fedexLabelId: row?.original?.id })
          }
        />
      </td>
    );
  }
  return (
    <Fragment>
      <td>
        <Button
          textInformation={{ text: "View", fontWeight: "font-semibold" }}
          buttonTheme="secondary"
          className=""
          onClick={togglePopup}
        />
      </td>
    </Fragment>
  );
}

export default ViewOrders;
